<ng-template #modal>
  <div class="modal-form-content">
    <div class="modal-header">
      <div>
        <h4 class="modal-title fw-bold mb-0">{{ modalConfig.modalTitle }}</h4>
        <div *ngIf="modalConfig.modalSubtitle" class="text-gray-900 fs-7 mt-1">
          {{ modalConfig.modalSubtitle() }}
        </div>
      </div>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="close()"
        [style.pointer-events]="modalConfig.disableCloseButton?.() === true ? 'none' : 'initial'"
      ></button>
    </div>

    <div class="modal-body">
      <ng-content></ng-content>
    </div>

    <div
      *ngIf="modalConfig.showFooter"
      class="modal-footer d-flex flex-nowrap align-items-center border-top px-7 py-5"
    >
      <ng-content select="[data-modalFooter]"></ng-content>
    </div>
  </div>
</ng-template>
